import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as EmailSearchSelectors from './email-search.selectors';
import * as EmailSearchActions from './email-search.actions';
import { EmailSearchFacade, SearchEmailPayload } from '@mode/shared/schedules/contract';

@Injectable()
export class EmailSearchFacadeService extends EmailSearchFacade {
  constructor(private store: Store) {
    super();
  }

  loaded$ = this.store.pipe(select(EmailSearchSelectors.selectEmailSearchLoaded));
  searchResults$ = this.store.pipe(select(EmailSearchSelectors.selectEmailSearchResults));

  searchEmail(props: SearchEmailPayload) {
    this.store.dispatch(EmailSearchActions.searchEmail(props));
  }
}
